/** Cashfree PG dispute evidence types — must match payment-service contract. */
export const CASHFREE_DISPUTE_DOC_TYPES = [
  "Delivery/Service Proof",
  "Shipping Proof",
  "Statement of Service",
  "Proof of Service Used",
  "Cancellation of Service Proof",
  "Refund Proof",
  "Business model explanation",
  "Extra Charges Declaration",
  "Terms & Conditions",
  "Customer Withdrawal Letter",
  "Certificate of Authenticity",
  "Reseller Agreement",
] as const;

export type CashfreeDisputeDocType = (typeof CASHFREE_DISPUTE_DOC_TYPES)[number];

export const isCashfreeGateway = (gateway?: string) =>
  gateway?.toUpperCase() === "CASHFREE";
